// Sample data for the football club website

export const carouselSlides = [
  {
    id: 1,
    title: "მოგესალმებით საფეხბურთო კლუბ ივერიაში",
    description: "პროფესიონალური ფეხბურთის კლუბი, რომელიც მიზნად ისახავს ქართული ფეხბურთის განვითარებას",
    image: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80",
    buttonText: "კლუბის შესახებ"
  },
  {
    id: 2,
    title: `ახალი სეზონი ${new Date().getFullYear()}`,
    description: "მოვემზადებით ახალი სეზონისთვის და ვიმედოვნებთ დიდ წარმატებებს",
    image: "/new.jpg",
    buttonText: "გუნდის ნახვა"
  },
  {
    id: 3,
    title: "ახალგაზრდული აკადემია",
    description: "ჩვენი ახალგაზრდული აკადემია აღზრდის მომავალი ვარსკვლავების",
    image: "/image1.jpg",
    buttonText: "აკადემია"
  }
];

export const nextMatch = {
  homeTeam: {
    name: "FC ივერია",
    logo: "https://via.placeholder.com/64x64/3B82F6/FFFFFF?text=FC"
  },
  awayTeam: {
    name: "დინამო თბილისი",
    logo: "https://via.placeholder.com/64x64/8B5CF6/FFFFFF?text=DT"
  },
  date: "2024-09-15T15:00:00.000Z",
  venue: "ივერიის სტადიონი",
  league: "ეროვნული ლიგა"
};

export const news = [
  {
    id: 1,
    title: "FC ივერიამ მოიგო მნიშვნელოვანი მატჩი",
    excerpt: "ჩვენმა გუნდმა შესანიშნავი თამაშით დაამარცხა მოწინააღმდეგე და მნიშვნელოვანი ქულები მოიპოვა.",
    content: "სრული ამბავი აქ იქნება...",
    image: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80",
    date: "2024-09-10",
    category: "მატჩი"
  },
  {
    id: 2,
    title: "ახალი ფეხბურთელის ხელმოწერა",
    excerpt: "კლუბმა ახალი ფეხბურთელი ხელი მოაწერა, რომელიც გუნდს დაეხმარება მომავალ სეზონში.",
    content: "სრული ამბავი აქ იქნება...",
    image: "https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80",
    date: "2024-09-08",
    category: "ტრანსფერი"
  },
  {
    id: 3,
    title: "აკადემიის წარმატება",
    excerpt: "ჩვენი U-17 გუნდი მოიგო რეგიონული ჩემპიონატი და წავიდა ეროვნულ ტურნირში.",
    content: "სრული ამბავი აქ იქნება...",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80",
    date: "2024-09-05",
    category: "აკადემია"
  }
];

export const standings = [
  {
    id: 1,
    name: "FC ივერია",
    logo: "https://via.placeholder.com/32x32/3B82F6/FFFFFF?text=FC",
    played: 8,
    won: 6,
    drawn: 1,
    lost: 1,
    goalsFor: 18,
    goalsAgainst: 8,
    points: 19,
    isCurrentTeam: true
  },
  {
    id: 2,
    name: "დინამო ბათუმი",
    logo: "https://via.placeholder.com/32x32/EF4444/FFFFFF?text=DB",
    played: 8,
    won: 5,
    drawn: 2,
    lost: 1,
    goalsFor: 15,
    goalsAgainst: 6,
    points: 17,
    isCurrentTeam: false
  },
  {
    id: 3,
    name: "საბურთალო თბილისი",
    logo: "https://via.placeholder.com/32x32/10B981/FFFFFF?text=ST",
    played: 8,
    won: 4,
    drawn: 3,
    lost: 1,
    goalsFor: 12,
    goalsAgainst: 7,
    points: 15,
    isCurrentTeam: false
  },
  {
    id: 4,
    name: "დინამო თბილისი",
    logo: "https://via.placeholder.com/32x32/8B5CF6/FFFFFF?text=DT",
    played: 8,
    won: 4,
    drawn: 2,
    lost: 2,
    goalsFor: 14,
    goalsAgainst: 10,
    points: 14,
    isCurrentTeam: false
  },
  {
    id: 5,
    name: "ლოკომოტივი თბილისი",
    logo: "https://via.placeholder.com/32x32/F59E0B/FFFFFF?text=LT",
    played: 8,
    won: 3,
    drawn: 4,
    lost: 1,
    goalsFor: 11,
    goalsAgainst: 9,
    points: 13,
    isCurrentTeam: false
  }
];










